import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { whatYouWillGetHeight } from '@/components/Subscription/PlanTable';

interface Props {
  title?: string;
  className?: string;
  classes?: {
    childDivClass?: string;
    pClass?: string;
  };
  style?: React.CSSProperties;
}

const H2Cell: FC<Props> = ({ title, className, style }) => {
  return (
    <div
      style={{ height: whatYouWillGetHeight, ...style }}
      className={twMerge('bg-grayZl-950  px-4 flex items-center', className)}
    >
      <p className='text-xs leading-5 uppercase tracking-[1.8px] text-primary font-normal'>
        {title}
      </p>
    </div>
  );
};

export default H2Cell;
